import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "var(--color-gray-600)",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M21 12a9 9 0 1 0-18 0 9 9 0 0 0 18 0m2 0c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11" }, null, -1),
    _createElementVNode("path", { d: "M12 15a10.97 10.97 0 0 1 7.856 3.3 1 1 0 0 1-1.43 1.4A8.97 8.97 0 0 0 12 17a8.97 8.97 0 0 0-6.428 2.7 1 1 0 0 1-1.427-1.4A10.97 10.97 0 0 1 12 15M15 9a3 3 0 1 0-6 0 3 3 0 0 0 6 0m2 0A5 5 0 1 1 7 9a5 5 0 0 1 10 0" }, null, -1)
  ]))]))
}
export default { render: render }